import React, { ReactElement } from 'react'

import { TrainingGroup } from '../../../types/training'
import TrainingCards from '../../../components/Admin/training/preview-training'
import { StyledAdmin } from '../styled-components'

interface TrainingGroupProps {
  trainingsGroup: TrainingGroup
}

const TrainingGroupScreen = ({
  trainingsGroup,
}: TrainingGroupProps): ReactElement => (
  <StyledAdmin>
    <TrainingCards adminTemplate trainingsGroup={trainingsGroup} />
  </StyledAdmin>
)

export default TrainingGroupScreen
